export const NH_CONSENT_CONFIGURATION_TYPE = 'referral';
export const NH_REFERRAL_CONSENT_CODE = 'nh_referral_v1';
export const NH_DATA_SHARE_CONSENT_CODE = 'nh_data_share_v1';
